import {getAppearanceBaseSettingsQuery} from './get-appearance-base-settings'
import {getAppearanceTemplateByIdQuery} from './get-appearance-template'

export const DisplaySettingsQueries = {
  getAppearanceTemplateByIdQuery,
  getAppearanceBaseSettingsQuery,
}
